"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Crop_1 = __importDefault(require("./Crop"));
const Proposal_1 = __importDefault(require("./Proposal"));
const emptyData = {
    type: '',
    name: '',
    date: '',
    extension: 0,
    extensionUnit: '',
    previewData: {
        lat: 0,
        log: 0,
        score: 0,
        categorie: '',
        qrValid: '',
        qrCode: '',
        resultUrl: '',
        geodata: ''
    },
    crop: new Crop_1.default(),
    proposal: new Proposal_1.default(),
};
class ProjectRate {
    constructor(data = emptyData) {
        this.type = data.type || '';
        this.name = data.name || '';
        this.date = data.date || '';
        this.extension = data.extension || 0;
        this.extensionUnit = data.extensionUnit || '';
        this.previewData = data.previewData || emptyData.previewData;
        this.crop = data.crop || new Crop_1.default();
        this.proposal = data.proposal || new Proposal_1.default();
    }
}
exports.default = ProjectRate;
